import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CbInfoMessageModule, CbLoadingSpinnerModule, CbTableModule } from 'cb-hub-lib';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { CbClickModule } from '@app/shared/directives/click/click.module';
import { CbHubTableModule } from '@app/shared/components/table/table.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CbDialogModule } from '@app/shared/components/dialog/dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbSortByModule } from '@app/shared/pipe/sort-by/sort-by.module';
import { SecurityRoleViewComponent } from './security-role-view/security-role-view.component';
import { SecurityRoleReportDialogComponent } from './security-role-report-dialog/security-role-report-dialog.component';
import { SecurityRoleListComponent } from './security-role-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        SecurityRoleListComponent,
        SecurityRoleReportDialogComponent,
        SecurityRoleViewComponent
    ],
    imports: [
        RouterModule.forRoot([
            {
                component: SecurityRoleListComponent,
                path: 'security-roles',
                data: {
                    breadcrumb: 'Security Roles',
                }
            },
            {
                component: SecurityRoleViewComponent,
                path: 'security-roles/view/:id',
                data: {
                    breadcrumb: 'Security Role View',
                    breadcrumbPredecessors: [
                        { label: 'Security Roles', url: 'security-roles' }
                    ]
                }
            },
            {
                component: SecurityRoleViewComponent,
                path: 'security-roles/create',
                data: {
                    breadcrumb: 'Security Role Create',
                    breadcrumbPredecessors: [
                        { label: 'Security Roles', url: 'security-roles' }
                    ]
                }
            }
        ], {}),
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbDisplayValueModule,
        CbClickModule,
        CbHubTableModule,
        CbTableModule,
        CbSortByModule,
        MatTabsModule,
        MatGridListModule,
        CbWaitForModule,
        MatDividerModule,
    ]
})
export class SecurityRolesModule { }
